class APIPlatformRouter {
    constructor() {
        this.divisions = '/api/divisions';
        this.dockyards = '/api/dockyards';
        this.dockyardAreas = '/api/dockyard-areas';
        this.areaTypes = '/api/area-types';
    }
}

export default new APIPlatformRouter();